import React, { useState } from 'react';

// Question illustration with a loading placeholder. Until the image loads we
// reserve the 16:9 slot and show a spinner + "Loading image…", so the sheet
// doesn't jump when the image pops in. On error (or no src) we render nothing.
//
// 16:9 + cover since 2026-07-30, in lockstep with every iOS question-image
// slot and the Auto-Pilot engine's pinned native render ratio
// (functions/src/clients/geminiImageClient.ts). Cover, not contain: legacy
// square assets from before the ratio pin crop slightly rather than
// letterboxing against the card background.
export default function QuestionImage({ src, alt }) {
  const [state, setState] = useState('loading'); // loading | ready | error
  if (!src || state === 'error') return null;
  return (
    <div style={wrap}>
      {state !== 'ready' && (
        <div style={placeholder} role="status" aria-label="Loading image">
          <span className="ps-spinner" aria-hidden="true" />
          <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--secondary-text)' }}>
            Loading image…
          </span>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        onLoad={() => setState('ready')}
        onError={() => setState('error')}
        style={{ ...img, opacity: state === 'ready' ? 1 : 0 }}
      />
    </div>
  );
}

const wrap = {
  position: 'relative',
  width: '100%',
  aspectRatio: '16 / 9',
  borderRadius: 'var(--radius-sm)',
  overflow: 'hidden',
  marginBottom: 14,
  background: 'var(--card-bg)',
};
const placeholder = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  border: '1px solid var(--border)',
  borderRadius: 'var(--radius-sm)',
};
const img = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transition: 'opacity 0.25s ease',
};
